export interface Connector {
    id: string;
    label: string;
    icon: string;
    isConfigured: boolean;
    // Called early: the consent popup must open within the click.
    preload(): Promise<void>;
    // Resolves empty when nothing is picked.
    pick(): Promise<File[]>;
    // Drops any access held for the person who was signed in.
    forget?(): void;
}

export class PickCancelled extends Error {
    constructor() {
        super("The picker was closed");
        this.name = "PickCancelled";
    }
}
